import axios from "@/api/axiosInstance";
import { FetchCatalogProductResponse } from "./types";

export const fetchCatalogProduct = async (
  id: string,
  signal?: AbortSignal,
): Promise<FetchCatalogProductResponse> => {
  const response = await axios.get<FetchCatalogProductResponse>(
    `/api/private/product-catalog/products/${id}`,
    { signal },
  );
  return response.data;
};
